import { render, staticRenderFns } from "./BaseURLInput.vue?vue&type=template&id=18323c51&scoped=true&"
import script from "./BaseURLInput.vue?vue&type=script&lang=js&"
export * from "./BaseURLInput.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/base.css?vue&type=style&index=0&id=18323c51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18323c51",
  null
  
)

export default component.exports